<template>
    <v-container class="flex-column">
        <v-row>
            <v-col cols="12">
                <v-select
                    v-model="value.state"
                    :items="states"
                    dense
                    hide-details
                    label="Состояние"
                >
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model.number="value.x_coord"
                    min="0"
                    :max="reservoir.grids_x * reservoir.dx"
                    dense
                    hide-details
                    type="number"
                    label="X"
                >
                    <template #append>м</template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model.number="value.y_coord"
                    min="0"
                    :max="reservoir.grids_y * reservoir.dy"
                    dense
                    hide-details
                    type="number"
                    label="Y"
                >
                    <template #append>м</template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model.number="value.z_coord_relative"
                    min="0"
                    :max="reservoir.grids_z * reservoir.dz"
                    dense
                    hide-details
                    type="number"
                    label="Z (относительная)"
                >
                    <template #append>м</template>
                </v-text-field>
                {{value ? value.z_coord : ""}}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model.number="value.h_net_thickness"
                    min="0"
                    dense
                    hint="Толщина нефтеносного слоя"
                    persistent-hint
                    type="number"
                    label="h"
                >
                    <template #append>м</template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model.number="value.l_perforation_length"
                    min="0"
                    dense
                    hint="Длина перфорации"
                    persistent-hint
                    type="number"
                    label="l"
                >
                    <template #append>м</template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model.number="value.sw_water_saturation"
                    min="0" max="1" step="0.1"
                    dense
                    hide-details
                    type="number"
                    label="p"
                >
                    <template #label>S<sub>w</sub></template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model.number="value.k_permeability"
                    min="0"
                    dense
                    hide-details
                    type="number"
                    label="k"
                >
                    <template #append>мД</template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model.number="value.p_pressure"
                    min="0"
                    dense
                    hide-details
                    type="number"
                    label="p"
                >
                    <template #append>бар</template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model.number="value.phi_porosity"
                    min="0"
                    dense
                    hide-details
                    type="number"
                >
                    <template #label>&phi;</template>
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {STATE_OPEN, STATE_SHUT, STATE_AUTO} from "@/Well";

export default {
    props: ['value', 'reservoir'],
    data() {
        return {
            states: [
                {text: 'Открыта', value: STATE_OPEN},
                {text: 'Закрыта', value: STATE_SHUT},
                {text: 'Авто', value: STATE_AUTO},
            ]
        }
    }
}
</script>

<style scoped>

</style>
